// reducer.ts
import { createReducer, on } from '@ngrx/store';
import { loadListSuccess, loadListFailure } from './action';
import {loadObjectSuccess} from './action'

// Define a type for list states with specific properties
interface ListState {
  application: any[];
  country: any[];
  data:any;
  error: { [key: string]: any } | null; // Manage errors separately
}

export const initialState: ListState = {
  application: [],
  country: [],
  data:null,
  error: null,
};

export const listReducer = createReducer(
  initialState,
  on(loadListSuccess, (state, { listType, items }) => ({
    ...state,
    [listType]: items,
    error: { ...state.error, [listType]: null }
  })),
  on(loadListFailure, (state, { listType, error }) => ({
    ...state,
    [listType]: [],
    error: { ...state.error, [listType]: error }
  }))
);

export const dataReducer = createReducer(
  initialState,
  on(loadObjectSuccess, (state, { data }) => {
    return {
      ...state,
      data: data,
    };
  })
);
